import { Button, List } from 'antd'
import * as React from 'react'

import { TodoItem, TodoListItem } from './'

import * as styles from './TodoList.module.less'

export interface TodoListProps {
	header?: React.ReactNode
	todoItemList: TodoItem[]

	addTodoItem: (title: string) => void
	deleteTodoItem: (id: string) => void
	renameTodoItem: (id: string, title: string) => void
	toggleTodo: (id: string) => void
}

export const TodoList: React.FC<TodoListProps> = (props) => {
	const { addTodoItem, deleteTodoItem, header, renameTodoItem, todoItemList, toggleTodo } = props

	const handleAddItem = () => {
		addTodoItem('new todo')
	}

	return (
		<div>
			<List
				bordered={false}
				className={styles.todoList}
				header={header}
				itemLayout='horizontal'
				size='small'
				dataSource={todoItemList}
				renderItem={(item) => (
					<TodoListItem {...item} deleteTodoItem={deleteTodoItem} toggleTodo={toggleTodo} renameTodoItem={renameTodoItem} />
				)}
			/>
			<Button style={{ marginLeft: '2rem', marginTop: '1rem' }} size='small' onClick={handleAddItem}>
				Add an item
			</Button>
		</div>
	)
}
